import { LOCALES_ALIASES } from './constants';

export const getEffectiveLocale = (locale: string) => {
  if (locale in LOCALES_ALIASES) {
    return LOCALES_ALIASES[locale];
  }

  const [localePart, regionPart] = locale.split('-');
  if (!regionPart) {
    return localePart;
  }

  return `${localePart}-${regionPart.toUpperCase()}`;
};
